import { render, staticRenderFns } from "./SavedQueries.vue?vue&type=template&id=14c502fc"
import script from "./SavedQueries.vue?vue&type=script&lang=js"
export * from "./SavedQueries.vue?vue&type=script&lang=js"
import style0 from "./SavedQueries.vue?vue&type=style&index=0&id=14c502fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports